import React from "react";
import { TextField, Button, Box, Grid, Typography } from "@mui/material";

const QuoteForm = () => {
  return (
    <Box
      sx={{
        minWidth: {md:"800px"}, 
        margin: "0 auto", 
        padding:'0'
      }}
     
    >
      <Grid container spacing={0} sx={{padding:'0'}}>
        {/* Left Side: Background Image */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: { xs: "none", md: "block" ,}, padding:'0px' 
          }}
        >
          <Box
            sx={{
              height: "100%",
              minHeight: "400px", // Minimum height for the left side
              backgroundImage: "url('https://suffescom.co/assets/images/letstratmodalbg2.webp')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderTopLeftRadius: "8px",
              borderBottomLeftRadius: "8px",
              overflow: "hidden",
              padding:0
            }}
          ></Box>
        </Grid>

        {/* Right Side: Form Inputs */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            padding: 2, // Add some padding for the form content
            display: "flex",
            alignItems: "center", // Vertically center the form
            justifyContent: "center", // Horizontally center the form
            flexDirection: "column",
           
            borderTopRightRadius: "8px", // Rounded corner at the top right
            borderBottomRightRadius: "8px", // Rounded corner at the bottom right
          }}
        >
            <Typography variant="h4" sx={{fontSize:"23px" , textAlign:"center" , fontWeight:"bold" ,  marginBottom:'5px'}}>
                Get Free Consultation From Top Industry Experts
            </Typography>
          <Box
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%", // Ensure form spans full width of the grid
              maxWidth: "400px", // Optional: Set a max width for the form
            }}
          >
            <TextField label="Name" variant="outlined" fullWidth required />
            <TextField label="Email" variant="outlined" fullWidth required />
            <TextField label="Phone" variant="outlined" fullWidth required />
            <TextField
              label="Message"
              variant="outlined"
              fullWidth
              multiline
              rows={2}
              required
            />
            <p
              style={{
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Your idea is protected with us.
            </p>
            <Button variant="contained" color="primary" type="submit" fullWidth>
              Submit
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default QuoteForm;
